<template>
    <div class="user-card">
        <div class="user-info-wrapper">
            <div class="user-info">
                <div class="user-info__avatar" @click="openUserDetail(data.id)">
                    <img :src="data.avatar || avatarUrl" />
                </div>
                <div class="user-info__main">
                    <div class="user-name" @click="openUserDetail(data.id)">{{ data.name || '无名大师' }}</div>
                    <!-- <div class="user-tag">{{ item.area }} | {{ item.tag }}</div> -->
                    <div class="user-fans">创作 {{ data.create }} | 粉丝 {{ data.follow }}</div>
                </div>
            </div>

            <el-button :type="isFollow ? '' : 'primary'" size="small" class="follow-button" @click="toggleFollow(data)" v-if="showFollowBtn">
                {{ isFollow ? '取消关注' : '关注' }}
            </el-button>
        </div>
        <div class="user-creation">
            <div class="user-creation__item" v-for="(image, i) in data.imageList" :key="'image' + i" @click="openDetail(image)">
                <img :src="image.logo" />
            </div>
        </div>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapState } from 'vuex';
import { openWindow } from '@/utils/utils';
import {
    attentionUser,
    unAttentionUser
} from '@/api/user';

export default {
    name: 'UserCard',
    inject: ['checkToken'],
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        showFollowBtn: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        avatarUrl: '/static/images/user.png'
    }),
    computed: {
        ...mapState('user', ['userInfo']),
        isFollow() {
            let isFollow = false;
            if (this.userInfo && this.userInfo.id && this.data.isFollow) {
                isFollow = true;
            } else {
                isFollow = false;
            }
            return isFollow;
        }
    },
    methods: {
        openDetail(item) {
            let url = null;
            switch(item.tp) {
                case 1:
                    url = '/#/experience/detail/';
                    break;
                case 2:
                    url = '/#/works/detail/';
                    break;
                default:
                    break;
            }
            if (url) {
                openWindow(url + item.id);
            }
        },
        openUserDetail(id) {
            this.$router.push({
                name: 'User',
                params: { id }
            });
        },
        toggleFollow: debounce(function (item){
            if (!this.checkToken()) return;
            if (!item.isFollow) {
                attentionUser({ attentionUserId: item.id, userId: this.userInfo.id}).then(({ code }) => {
                    if (code === 0) {
                        this.$message.success('关注成功');
                    }
                }).finally(() => {
                    this.$set(item, 'isFollow', true);
                });
            } else {
                unAttentionUser({ attentionUserId: item.id, userId: this.userInfo.id}).then(({ code }) => {
                    if (code === 0) {
                        this.$message.success('已取消关注');
                    }
                }).finally(() => {
                    this.$set(item, 'isFollow', false);
                });
            }
        }, 300)
    }
};
</script>

<style lang="scss" scoped>
.user-card {
    height: 150px;
    display: flex;
    align-items: center;

    .user-info-wrapper {
        width: 210px;
        margin-right: 70px;

        .user-info {
            display: flex;
            align-items: center;
            height: 90px;

            &__avatar {
                width: 90px;
                height: 90px;
                margin-right: 10px;
                cursor: pointer;

                img {
                    width: 90px;
                    height: 90px;
                    border-radius: 50%;
                }
            }

            &__main {
                .user-name {
                    @include font(rgba(39, 44, 64, 1), 16px, 600);

                    &:hover {
                        color: rgba(47, 84, 235, 1);
                        cursor: pointer;
                    }
                }
                .user-tag {
                    margin-top: 5px;
                    @include font(rgba(113, 119, 152, 1), 14px, 600);
                }
                .user-fans {
                    margin-top: 15px;
                    @include font(rgba(39, 44, 64, 1), 14px, 400);
                }
            }
        }

        .follow-button {
            width: 95px;
            height: 30px;
            margin-top: 15px;
        }
    }

    .user-creation {
        width: 1150px;
        height: 150px;
        display: flex;

        &__item {
            width: 214px;
            height: 150px;
            cursor: pointer;
            border-radius: 6px;
            overflow: hidden;

            img {
                width: 214px;
                height: 150px;
                border-radius: 6px;
                transition: transform 0.35s;

                &:hover {
                    transform: scale(1.05);
                }
            }

            &:not(:first-child) {
                margin-left: 20px;
            }
        }
    }
}

// 小屏
@include mq($small) {
    .user-card {
        height: 120px;
        .user-info-wrapper {
            width: 180px;
            margin-right: 30px;

            .user-info {
                &__avatar {
                    width: 60px;
                    height: 60px;

                    img {
                        width: 60px;
                        height: 60px;
                    }
                }

                &__main {
                    .user-name {
                        margin-top: 8px;
                        @include font(rgba(39, 44, 64, 1), 14px, 600);
                    }
                }
            }

            .follow-button {
                margin-top: 10px;
            }
        }

        .user-creation {
            width: 910px;
            height: 120px;

            &__item {
                width: 170px;
                height: 120px;

                img {
                    width: 170px;
                    height: 120px;
                }

                &:not(:first-child) {
                    margin-left: 15px;
                }
            }
        }
    }
}
</style>
